
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabsforcorporateevent() {



    const cardData =
    {
        keyword: 'Cabs for Corporate Events in Pune',
        heading: 'S9 Travels:  Cabs for Corporate Events in Pune',
        headingDescription: 'S9 Travels offers Innova Cabs for Corporate Events in Pune, ensuring a comfortable, reliable, and premium travel experience. Whether you need transportation for business meetings, conferences, or corporate outings, our well-maintained Innova cabs provide the perfect solution. With spacious interiors, luxury features, and a smooth ride, your team can travel in comfort. Our professional drivers ensure a safe, punctual, and hassle-free journey, making your corporate travel seamless and efficient. Book with S9 Travels for a premium travel experience in Pune.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada is a must-see for history buffs. This grand palace was once the seat of the Peshwa rulers and offers fascinating glimpses into Pune's royal past. The light and sound show in the evening is a popular attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892, this beautiful palace is known for its historical significance, as it served as a prison for Mahatma Gandhi during the Indian independence struggle. The palace is surrounded by lush gardens and serves as a reminder of India’s freedom movement."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. A popular trekking destination, it is also rich in history, having been the site of many battles, including the famous Battle of Sinhagad."
    },
    {
      "title": "Osho Ashram",
      "description": "For those seeking peace and tranquility, the Osho Ashram in Pune is a renowned spiritual retreat. It offers yoga, meditation, and spiritual practices to rejuvenate your mind and body. It’s an ideal place for those looking for a calm and reflective experience."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This ancient rock-cut temple, dedicated to Lord Shiva, is located right in the heart of Pune. Carved out of a single rock, it is a serene and historical place, providing insight into ancient Indian architecture and religion."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses a wide collection of artifacts, including sculptures, paintings, and other cultural exhibits. It showcases the rich artistic heritage of India, with a special emphasis on Maharashtra's traditional art forms."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "For nature lovers and those looking for a peaceful escape, Khadakwasla Dam offers a scenic location to relax. It’s a popular spot for picnics, and you can enjoy the beauty of the surrounding hills and the cool breeze by the water."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known as the heart of Pune's youthful and energetic vibe, Fergusson College Road is a bustling area filled with cafes, bookshops, and vibrant street markets. It’s a great spot to experience Pune’s lively culture and shop for souvenirs."
    },
    {
      "title": "Lal Mahal",
      "description": "A significant historical landmark, Lal Mahal was the residence of Chhatrapati Shivaji Maharaj during his youth. It’s an important monument that offers insights into the life of the great Maratha king."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully landscaped park is a peaceful retreat with lovely walking paths, koi ponds, and traditional Japanese architecture. It's an ideal place for a serene walk or a family outing."
    }
],

"services": [
    {
      "name": "Book Cabs for Corporate Events in Pune",
      "description": "Planning a corporate event in Pune? Book cabs with S9 Travels to ensure smooth transportation for your attendees. We offer reliable, punctual, and comfortable cab services for business events, conferences, seminars, and more."
    },
    {
      "name": "Corporate Event Transportation in Pune",
      "description": "S9 Travels provides professional transportation services for corporate events in Pune. Whether it’s a large conference or a small business gathering, we ensure your guests arrive on time and in comfort with our well-maintained fleet of cabs."
    },
    {
      "name": "Affordable Cabs for Corporate Gatherings",
      "description": "Looking for affordable cabs for your corporate gatherings in Pune? S9 Travels offers competitive rates for reliable and comfortable transportation. Ensure your team or clients travel in style without breaking the budget."
    },
    {
      "name": "Book Taxis for Business Events in Pune",
      "description": "Need a taxi for a business event in Pune? S9 Travels offers easy and quick booking for taxis to and from corporate events. Whether it’s a conference, meeting, or seminar, we ensure timely arrivals and departures with our professional taxi service."
    },
    {
      "name": "Professional Cabs for Corporate Conferences in Pune",
      "description": "S9 Travels offers professional cab services for corporate conferences in Pune. Ensure your attendees have a comfortable and punctual ride to and from your conference, making sure your event runs smoothly."
    },
    {
      "name": "Pune Cabs for Corporate Seminars and Workshops",
      "description": "Need transportation for a corporate seminar or workshop in Pune? Book cabs with S9 Travels for reliable and comfortable transport for your participants. We ensure on-time arrivals and departures for a hassle-free event."
    },
    {
      "name": "Event Transportation Services in Pune",
      "description": "S9 Travels specializes in event transportation services in Pune. Whether you're hosting a corporate seminar, conference, or business gathering, we provide tailored transportation solutions to meet the needs of your event."
    },
    {
      "name": "Business Meeting Transport in Pune",
      "description": "For business meetings in Pune, S9 Travels offers punctual and professional transport services. Whether it's for a small group or a large team, we ensure smooth, reliable, and comfortable transportation."
    },
    {
      "name": "Corporate Travel Solutions in Pune",
      "description": "S9 Travels offers comprehensive corporate travel solutions in Pune. From airport transfers to transportation for business meetings and events, our services cater to all your corporate travel needs with comfort and reliability."
    },
    {
      "name": "Group Cabs for Corporate Functions",
      "description": "For group transportation needs during corporate functions in Pune, S9 Travels provides spacious and comfortable group cabs. Whether it’s a team outing, business event, or seminar, we ensure your entire group travels together in comfort."
    },
    {
      "name": "Pune Corporate Event Logistics",
      "description": "S9 Travels handles corporate event logistics in Pune, ensuring timely and efficient transportation for all attendees. From the arrival to departure, we take care of the transport, so you can focus on managing your event."
    },
    {
      "name": "Executive Car Hire for Business Events",
      "description": "S9 Travels offers executive car hire services for business events in Pune. Whether it’s for high-level executives or VIP guests, our premium fleet and professional chauffeurs ensure a luxurious and comfortable experience."
    }
],

"tableData": [
  ["Book Cabs for Corporate Events in Pune", "Corporate Event Transportation in Pune"],
  ["Affordable Cabs for Corporate Gatherings", "Book Taxis for Business Events in Pune"],
  ["Professional Cabs for Corporate Conferences in Pune", "Pune Cabs for Corporate Seminars and Workshops"],
  ["Event Transportation Services in Pune", "Business Meeting Transport in Pune"],
  ["Corporate Travel Solutions in Pune", "Group Cabs for Corporate Functions"],
  ["Pune Corporate Event Logistics", "Executive Car Hire for Business Events"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Timely and Efficient Service",
    "WhyChoosedescription": "For corporate events, punctuality is key. S9 Travels ensures that our cabs arrive on time, so your employees and guests never miss an important moment. Our professional drivers are dedicated to providing timely service for smooth event transportation."
  },
  {
    "WhyChooseheading": "Luxury and Comfort for Your Guests",
    "WhyChoosedescription": "Make a lasting impression at your corporate event by offering your guests a premium travel experience. Our fleet of luxury vehicles, including Toyota Innova, provides comfort, ample space, and stylish interiors, ensuring a smooth ride for your corporate attendees."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Corporate Travel",
    "WhyChoosedescription": "Our drivers are highly trained to handle corporate travel with professionalism and discretion. With extensive knowledge of the best routes and traffic patterns, they ensure that your guests arrive at the event location efficiently and without stress."
  },
  {
    "WhyChooseheading": "Seamless Group Transportation",
    "WhyChoosedescription": "Whether you're transporting a small group or a large number of people, we offer flexible options for group transportation. Our cabs can accommodate various group sizes, making it easier to manage the logistics for your corporate event."
  },
  {
    "WhyChooseheading": "Tailored Packages for Corporate Events",
    "WhyChoosedescription": "S9 Travels offers customized travel packages for corporate events. From airport transfers to multiple trips across different venues, we work with you to tailor the transportation plan to fit the needs of your event, ensuring an efficient and stress-free experience."
  },
  {
    "WhyChooseheading": "Corporate Discounts and Special Rates",
    "WhyChoosedescription": "We understand the importance of keeping corporate event budgets in check. That’s why we offer competitive pricing and special discounts for corporate event transportation. We work with you to create an affordable solution that meets your event’s transportation needs."
  },
  {
    "WhyChooseheading": "Reliable and Secure Travel",
    "WhyChoosedescription": "Safety is a priority when transporting corporate guests. Our cabs are equipped with modern safety features like GPS tracking, airbags, and seat belts, ensuring that your guests travel in safety and comfort throughout the event."
  },
  {
    "WhyChooseheading": "Flexible Availability for Corporate Events",
    "WhyChoosedescription": "Whether your corporate event runs early in the morning or late into the night, S9 Travels is available to provide transportation services 24/7. We ensure that our drivers are ready to accommodate your event’s schedule and any changes that might arise."
  }
]







    }



    const faqData = [
        [
          {
            question: 'How can I book cabs for a corporate event with S9 Travels?',
            answer: 'Booking cabs for a corporate event is easy! You can book online via our website or app, or get in touch with our customer service team to discuss your event details and requirements for a seamless booking experience.',
          },
          {
            question: 'What types of vehicles are available for corporate events?',
            answer: 'We offer a wide range of vehicles Efficient for corporate events, including luxury sedans, SUVs, and spacious Innova cabs, ensuring that you can transport your team or guests in style and comfort.',
          },
          {
            question: 'Can I arrange transportation for large corporate groups?',
            answer: 'Yes, we provide transportation for large groups. We can accommodate multiple people with our fleet of vehicles, including minibuses and multiple cabs, ensuring that your entire team or guest list is transported efficiently.',
          },
          {
            question: 'Are the drivers experienced for corporate event transportation?',
            answer: 'Absolutely! Our drivers are highly experienced and trained to provide professional service for corporate events. They are punctual, courteous, and well-versed in navigating event venues to ensure smooth transportation.',
          },
          {
            question: 'Do you offer services for airport transfers for corporate events?',
            answer: 'Yes, we provide reliable and timely airport transfers for corporate events. Whether it’s for picking up VIP guests or your event team, we ensure a smooth and comfortable airport transportation experience.',
          },
          {
            question: 'Can I customize my booking based on the event’s timing?',
            answer: 'Yes, we offer flexible booking options to suit the timing of your corporate event. You can adjust the pickup and drop-off schedules, and we’ll ensure that the transportation is perfectly aligned with your event’s needs.',
          },
          {
            question: 'Are the vehicles well-maintained and clean for corporate events?',
            answer: 'Yes, all our vehicles are meticulously maintained, clean, and equipped with all the necessary amenities to provide a comfortable and professional experience for your corporate event transportation.',
          },
          {
            question: 'Is there a minimum booking duration for corporate event transport?',
            answer: 'We offer flexible booking durations, but for corporate events, there may be a minimum duration to ensure availability and smooth operations. Contact us to discuss the specifics for your event’s needs.',
          },
          {
            question: 'Can I book a cab for multiple corporate events over a few days?',
            answer: 'Yes, we can arrange for cabs to be available over multiple days for your corporate events. Just let us know your event schedule, and we’ll make the necessary arrangements to provide reliable transport throughout the duration of your event.',
          },
          {
            question: 'Why should I choose S9 Travels for my corporate event transportation in Pune?',
            answer: 'S9 Travels offers reliable, professional, and comfortable transportation for corporate events. With a fleet of well-maintained vehicles and experienced drivers, we ensure that your corporate event runs smoothly, with timely arrivals and departures, and a stress-free travel experience for your guests and team.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sanjay Verma',
          designation: 'Event Manager',
          rating: [1, 1, 1, 1, 1],
          text: '“We used S9 Travels for transportation during a corporate conference, and their service was exceptional. The vehicles were top-notch, the drivers were professional, and the whole process was seamless. I’ll definitely rely on them for future events.”',
        },
        {
          name: 'Mrs. Ayesha Khan',
          designation: 'Corporate Coordinator',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made transportation for our corporate event in Pune so easy. The drivers were punctual, and the vehicles were clean and comfortable. Their attention to detail and professionalism made our event even better. Highly recommend them for corporate event transportation!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Cabs for Corporate Events in Pune",
        "description": "Book professional cabs for corporate events in Pune, including conferences, seminars, workshops, and business meetings. S9 Travels offers affordable and reliable transportation for corporate gatherings, group travel, and executive car hire for corporate functions in Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      


    return (
        <div>
        

        <Helmet>
        <title>Cabs for Corporate Events in Pune | Affordable Business Event Transport | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book cabs for corporate events in Pune, including conferences, seminars, and business meetings. Affordable and reliable transportation solutions for corporate gatherings, group travel, and executive car hire with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
     
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabsforcorporateevent;